import { render, staticRenderFns } from "./ServiceStyle.vue?vue&type=template&id=6fc6a3dc"
import script from "./ServiceStyle.vue?vue&type=script&lang=js"
export * from "./ServiceStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports